<template>
    <div>
        <a href="" class="info" @click.prevent="openItem"
            >{{ title }}

            <span v-if="!isFuture">
                <chevron-down-icon class="arrow" v-if="!open" /><chevron-up-icon
                    class="arrow"
                    v-else
                />
            </span>
            <span v-else>
                <span v-if="!xpanded">
                    <chevron-up-icon class="downArrow" />
                    <chevron-down-icon class="upArrow" />
                </span>

                <span v-else>
                    <chevron-up-icon class="upArrow" />
                    <chevron-down-icon class="downArrow" />
                </span>
            </span>
        </a>

        <ul v-if="open">
            <li v-if="dates.length == 0">
                <empty-placeholder class="mt30 mb10 info2" v-if="title == 'Todays bookings'">
                    TIP: This is where your bookings for today will go.
                </empty-placeholder>

                <empty-placeholder v-else class="mt30 mb10 info2">
                    TIP: All future bookings will appear in a date ordered list here.
                </empty-placeholder>
            </li>
            <upcoming-lesson-item-lesson
                :ref="'item-' + isFuture"
                v-for="(lesson, date) in dates"
                :key="lesson.id"
                :lesson="lesson"
                :date="date"
                :title="title"
            />
        </ul>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";

import UpcomingLessonItemLesson from "@/components/Pro/Lessons/upcoming-lesson-item-lesson";
import { ChevronUpIcon, ChevronDownIcon } from "vue-feather-icons";
export default {
    name: "",
    components: { EmptyPlaceholder, UpcomingLessonItemLesson, ChevronUpIcon, ChevronDownIcon },
    props: ["title", "dates"],
    data() {
        return {
            open: true,
            xpanded: false,
        };
    },
    computed: {
        isFuture() {
            if (this.title == "Future bookings") {
                return "future";
            }
            return false;
        },
    },
    methods: {
        openItem() {
            if (this.title !== "Future bookings") {
                this.open = !this.open;
            } else {
                this.xpanded = !this.xpanded;

                if (!this.$refs["item-future"]) {
                    return;
                }

                Object.keys(this.$refs["item-future"]).forEach((key) => {
                    if (this.xpanded) {
                        this.$refs["item-future"][key].openIt();
                    } else {
                        this.$refs["item-future"][key].closeIt();
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    background: #1df19f;
    color: $green_0;
    font-size: 16px;
    margin-bottom: 10px;
    text-decoration: none;
    position: relative;
    .upArrow {
        position: absolute;
        bottom: 6px;
        right: 20px;
    }
    .downArrow {
        position: absolute;
        top: 6px;
        right: 20px;
    }
    &.date {
        background: #eef5f2;
        color: #b2bab3;
    }
    &.link {
        background: #bbf8e0;
    }
    .time {
        margin-right: 40px;
    }
}
.arrow {
    position: absolute;
    right: 20px;
    top: 15px;
    pointer-events: none;
}
</style>
